import { BalanceType } from '../models/Base';

import { PNGIconName } from './pngIcon';

// Define a subset type for currencies for ui
export type CurrencyType =
  | BalanceType.JoyPoint
  | BalanceType.BreadSlice
  | BalanceType.Diamond
  | BalanceType.Token
  // | BalanceType.CreationToken
  | StaminaType.GameStamina
  | StaminaType.CreationStamina;

export enum StaminaType {
  GameStamina = 'gameStamina',
  CreationStamina = 'creationStamina',
}

interface CurrencyDetails {
  icon: PNGIconName;
  displayName: string;
  fullyDisplayName: string;
  notEnoughMessage: string;
  description: string;
  registerText: string;
}

const currencyDetails: Record<CurrencyType, CurrencyDetails> = {
  [BalanceType.JoyPoint]: {
    icon: 'JCoin',
    displayName: 'J Coin',
    fullyDisplayName: 'J Coin',
    notEnoughMessage: 'Not Enough J Coin!',
    description: 'Earn J Coins by playing Memory Practices.',
    registerText: 'Register to get FREE J Coins!',
  },
  [BalanceType.BreadSlice]: {
    icon: 'Bread',
    displayName: 'Bread',
    fullyDisplayName: 'Bread',
    notEnoughMessage: 'Not Enough Bread!',
    description: 'Earn Bread by playing Memory Practices or by purchasing it.',
    registerText: '',
  },
  [BalanceType.Diamond]: {
    icon: 'Diamond',
    displayName: 'Diamonds',
    fullyDisplayName: 'Diamonds',
    notEnoughMessage: 'Not Enough Diamond!',
    description: '',
    registerText: '',
  },
  [BalanceType.Token]: {
    icon: 'Token',
    displayName: 'Token',
    fullyDisplayName: 'Token',
    notEnoughMessage: 'Not Enough Token!',
    description: "You can use Tokens when you don't have enough Stamina.",
    registerText: 'Register to get FREE Tokens!',
  },
  // [BalanceType.CreationToken]: {
  //   icon: 'CreationToken',
  //   displayName: 'Creation Tokens',
  //   fullyDisplayName: 'Creation Token (Permanent Use)',
  //   notEnoughMessage: 'Not Enough Creation Token!',
  //   description: 'Creation Tokens will not expire daily.',
  // },
  [StaminaType.GameStamina]: {
    icon: 'GameStamina',
    displayName: 'Practice Stamina',
    fullyDisplayName: 'Practice Stamina',
    notEnoughMessage: 'Not Enough Practice Stamina!',
    description:
      "Any unused Practice Stamina won't be carried forward to the next day.",
    registerText: 'Register to get FREE Practice Stamina!',
  },
  [StaminaType.CreationStamina]: {
    icon: 'CreationStamina',
    displayName: 'Creation Stamina',
    fullyDisplayName: 'Creation Stamina (Daily Use)',
    notEnoughMessage: 'Not Enough Creation Stamina!',
    description:
      "Any unused Creation Stamina won't be carried forward to the next day.",
    registerText: 'Register to get FREE Creation Stamina!',
  },
};

export const getCurrencyDetails = (
  balanceType: CurrencyType,
): CurrencyDetails => {
  return currencyDetails[balanceType];
};

export const BREAD_PRICES = {
  HKD: 7800,
  USD: 1000,
  TWD: 33000,
  CNY: 6800,
  // JPY: 120000,
};

export const SLICE_PER_BREAD = 500;
